import * as Yup from 'yup';

import { confirmPassword, advancedPassword } from 'utils/validation';

import { FormValues } from './types';

export const initialValues: FormValues = {
  password: '',
  oldPassword: '',
  passwordRepeat: '',
};

export const validationSchema = Yup.object().shape({
  password: advancedPassword,
  oldPassword: Yup.string().min(6).required(),
  passwordRepeat: confirmPassword(advancedPassword),
});
